<template>
  <div class="app-shell">
    <div class="router-wrapper">
      <RouterView />
    </div>
    <div class="demo-banner" v-if="isDemo && showNav">
      📌 演示版 · 当前内容为模拟数据，仅供展示参考
    </div>
    <nav class="bottom-nav" v-if="showNav">
      <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">
        <span class="nav-icon">🫂</span>
        <span class="nav-label">自由共学</span>
      </router-link>
      <router-link to="/cert" class="nav-item" :class="{ active: $route.path === '/cert' }">
        <span class="nav-icon">🏅</span>
        <span class="nav-label">组队认证</span>
      </router-link>
<!--       <router-link to="/benefits" class="nav-item" :class="{ active: $route.path === '/benefits' }">
        <span class="nav-icon">🎁</span>
        <span class="nav-label">权益</span>
      </router-link> -->
      <router-link v-if="isAdmin" to="/admin" class="nav-item" :class="{ active: $route.path === '/admin' }">
        <span class="nav-icon">⚙️</span>
        <span class="nav-label">管理</span>
      </router-link>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const showNav = computed(() => {
  const name = route.name as string;
  return name !== "login" && name !== "admin";
});
const isDemo = computed(() => import.meta.env.VITE_DEMO_MODE === "true");
const isAdmin = ref(false);

// Re-check admin status on every route change (handles login/logout without remounting App)
watch(() => route.path, async () => {
  const token = localStorage.getItem("rc_token");
  if (!token) { isAdmin.value = false; return; }
  try {
    const res = await fetch("/api/auth/me", {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    isAdmin.value = data.user?.role === "admin";
  } catch { isAdmin.value = false; }
}, { immediate: true });
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { background: #f5f0e8; }

.app-shell {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
}

.router-wrapper {
  flex: 1;
  overflow: hidden;
}

.bottom-nav {
  display: flex;
  background: #fff;
  border-top: 1px solid #e8e0d5;
  padding-bottom: env(safe-area-inset-bottom, 0);
  flex-shrink: 0;
  z-index: 20;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 0 6px;
  text-decoration: none;
  color: #b8a99a;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  border-top: 2px solid transparent;
  margin-top: -1px;
}

.nav-item.active {
  color: #e8894f;
  border-top-color: #e8894f;
  background: #fef9f2;
}

.nav-item:not(.active):hover {
  color: #9e7b5a;
}

.nav-icon {
  font-size: 20px;
  margin-bottom: 1px;
}

.nav-label {
  font-size: 11px;
  font-weight: 600;
}

.demo-banner {
  text-align: center;
  padding: 6px 16px;
  background: #fdf8ed;
  color: #9a7b2a;
  font-size: 12px;
  font-weight: 600;
  border-top: 1px solid #f0e8dd;
  flex-shrink: 0;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
}
</style>
